export const FlowGradientDefinitions = () => (
  <svg
    data-testid="gradient-defs"
    style={{ position: 'absolute', width: 0, height: 0, pointerEvents: 'none' }}
  >
    <defs>
      <linearGradient id="chosen-path-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" style={{ stopColor: 'hsl(var(--brand))' }} />
        <stop offset="100%" style={{ stopColor: 'hsl(var(--brand))' }} />
      </linearGradient>
      <marker
        id="chosen-path-marker"
        className="react-flow__arrowhead"
        markerWidth="12.5"
        markerHeight="12.5"
        viewBox="-10 -10 20 20"
        markerUnits="strokeWidth"
        orient="auto-start-reverse"
        refX="0"
        refY="0"
      >
        <polyline
          strokeLinecap="round"
          strokeLinejoin="round"
          points="-5,-4 0,0 -5,4 -5,-4"
          stroke="url(#chosen-path-gradient)"
          fill="url(#chosen-path-gradient)"
          strokeWidth="1"
        />
      </marker>
    </defs>
  </svg>
)
